import { action, toJS, observable } from 'mobx'
import Validator from 'validatorjs';

class BaseFormStore {
    constructor() {
        this.getFlattenedValues = this.getFlattenedValues.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
    }

    @observable loading = false;

    @observable
	form = {
        fields: {},
        meta: {}
    };

    getFlattenedValues(valueKey = 'value') {
        let data = {};
        let form = toJS(this.form).fields;
        Object.keys(form).map(key => {
            data[key] = form[key][valueKey]
        });
        return data
    };

    @action
    onFieldChange(fieldName, value) {
        this.setError(null);

        const field = this.form.fields[fieldName];
        if (field) {
            field.value = value;
            field.initialized = true;
            var validation = new Validator(
                { [fieldName]: field.value },
                { [fieldName]: field.rule }
            );
            
            field.isValid = validation.passes();    
            const errors = validation.errors;
            field.error = errors.has(fieldName) ? validation.errors.first(fieldName) : null;  

            var formValid = true;
            Object.keys(this.form.fields).forEach(key => {
                var innerField = this.form.fields[key];
                if (innerField.initialized && formValid)
                    formValid = field.isValid;
            })
            this.form.meta.isValid = formValid;
        }        
    };

    @action
    setError = (errMsg) => {
        this.form.meta.error = errMsg;
    }

    @action
    setLoading = (loading) => {
        this.loading = loading;
    }
}

export { BaseFormStore }


// WEBPACK FOOTER //
// ./src/stores/baseFormStore.js